/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

import { Confirm, Country } from "src/refresh/service/constant";
import { Address, BaseAddress, InputData } from "../data/input-data";
import { BaseCreator } from "./BaseCreator";

export class BCSLBCreator extends BaseCreator  {

       protected getDeliveryAddrorPOBox(addr:Address):string {
               if ( addr.chk_international !=  Confirm.YES ) 
                    return addr.deliveryAddr;   // for Canada
               else return addr.poBox;          // for International
       }

       protected getCountryCode(base:BaseAddress):number {
            if ( base.country == Country.CANADA ) {
                 return Number(base.province);
            }
            else return Number(base.country);
       }
}
